import React, { useState } from "react";
import styled from "styled-components";

export const Styles = styled.div`
  padding: 1rem;

  .table {
    display: inline-block;
    font-size: 11pt;
    font-family: Arial;
    border-collapse: collapse;
    border: 1px solid silver;

    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
      :nth-child(even) {
        background: rgb(88, 88, 88);
      }
      :hover {
        background: gold;
        color: rgb(19, 19, 19);
        cursor: pointer;
      }
    }

    .th,
    .td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      ${
        "" /* In this example we use an absolutely position resizer,
       so this is required. */
      }
      position: relative;

      :last-child {
        border-right: 0;
      }

      .resizer {
        display: inline-block;
        background: transparent;
        width: 1px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;
        ${"" /* prevents from scrolling while dragging on touch devices */}
        touch-action:none;

        &.isResizing {
          background: red;
        }
      }
    }
  }
`;
export const COLORS = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"];
export const color = [
  "#8884d8",
  "#82ca9d",
  "orange",
  "#FF6384",
  "#36A2EB",
  "pink",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
];

export const HandleSort = (item1, item2) => {
  // console.log(item1, item2);
  return 1;
};
/*
const [type, setType] = useState([]);
export const HandleChange = (e) => {
  setType(e.target.value);
};
*/

export const ReplaceKeys = (jsonData, keyMap) => {
  if (Array.isArray(jsonData)) {
    return jsonData.map((item) => ReplaceKeys(item, keyMap));
  } else if (typeof jsonData === "object" && jsonData !== null) {
    return Object.keys(jsonData).reduce((acc, key) => {
      const newKey = keyMap[key] || key;
      acc[newKey] = ReplaceKeys(jsonData[key], keyMap);
      return acc;
    }, {});
  }
  return jsonData;
};
